import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DbService, UploadTemplate } from '../service/db-service.service';
import { firstValueFrom, Observable } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IUserParam } from '../models/userparam.model';
import { IAppState } from '../models/app.state.model';
import { Store } from '@ngrx/store';
import { MatDialogModule, MatDialog, MatDialogConfig, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DeleteEventDialogComponent } from '../delete-event-dialog/delete-event-dialog.component';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ShowUploadsComponent } from "../show-uploads/show-uploads.component";
import { ReactiveFormsModule } from '@angular/forms'; 
import { MatRadioModule, MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import {DatePipe} from '@angular/common';
import { AdjustDateTimeDialogComponent } from '../adjust-date-time-dialog/adjust-date-time-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-eventsummary',
  imports: [ReactiveFormsModule,DatePipe, MatTableModule, MatDialogModule, MatDialogContent, MatDialogActions, MatCheckboxModule, MatRadioModule, MatRadioGroup, MatRadioButton, ShowUploadsComponent],
  templateUrl: './eventsummary.component.html',
  styleUrl: './eventsummary.component.sass'
})
export class EventsummaryComponent implements OnInit {
  
  @ViewChild('successfullySave') successfullySave!: TemplateRef<any>;
  @ViewChild('successfullyDelete') successfullyDelete!: TemplateRef<any>;
  @ViewChild('successfullyComplete') successfullyComplete!: TemplateRef<any>;
  myForm!: FormGroup;

  currentDate: Date = new Date();
  mode="";//delete or archive
  publishUrl: string = "";
  state: any;
  title: string;
  photocnt = 0;
  message="";
  showUploads = false;
  linkId: string;
  showNextStep = false;
  next = "";
  public userParamData$: Observable<IUserParam[]> = this.store.select((store) => store.userParam);
  constructor(private fb: FormBuilder,private dialog: MatDialog, private store: Store<IAppState>, private http: HttpClient, private router: Router, public dbService: DbService) {
     this.dbService.delItemsByPhoneMap = new Map();
  }

  ngOnInit(): void {
     this.myForm = this.fb.group({
      removetype: ['', Validators.required] 
    });
    if(!this.dbService.eventInitComplete){
      this.dbService.uploadStagingMap = new Map();
      this.userParamData$.subscribe((data) => {
        this.linkId = data[0].linkid;
      });
      this.dbService.eventid = this.dbService.selectedEvent.eventid as string;
      
      firstValueFrom(this.dbService.uploadedPersons(this.dbService.eventid, this.http))
      .then((result) => {
        const queryResults = result["QueryResults"];
        if(queryResults && queryResults.length > 0){
          const tempMap = queryResults[0]["imagemap"];
          if(tempMap != undefined){
            this.dbService.uploadStagingMap = new Map(Object.entries(tempMap));
          }
        }
      });
        firstValueFrom(this.dbService.uploadedMedia(this.dbService.eventid, this.http))
        .then((resp) => {
        //  console.log(JSON.stringify(resp));
          const myMap  = resp["rows"];
          const templatesObj = new Map(Object.entries(myMap));
          this.dbService.origTemplatesMap = structuredClone(templatesObj);
          this.dbService.updatedTemplatesMap = templatesObj;//make a copy in case user cancels delete
          console.log("class name is" + typeof(templatesObj));
          this.dbService.tableDataArray = [];
          Object.keys(resp["rows"]).forEach((key) => {
          const row = resp["rows"][key];
          const uploadTemplate:  UploadTemplate = {
              row: row, 
              description: row.description,
              eventid: row.eventid,
              filename: row.filename,
              filetype: row.filetype,     
              id: row.id,
              myname: row.myname,
              phone: row.phone,
              size: row.size,
              thumbfile: row.thumbfile,
              timestamp: row.timestamp,
              v4param1: row.v4param1,
              v4param2: row.v4param2,
              v4param3: row.v4param3
            };
            this.dbService.tableDataArray.push(uploadTemplate); 
            this.dbService.eventInitComplete = true; 
          });
          this.photocnt = this.dbService.tableDataArray.length;
          if(this.photocnt > 0){
            this.message = `${this.dbService.selectedEvent.title} has ${this.dbService.dataSource.data.length} photos.`; 
          }else{
            this.message = `No photos uploaded yet for ${this.dbService.selectedEvent.title}.`; 
          }
          this.dbService.dataSource = new MatTableDataSource<UploadTemplate>(this.dbService.tableDataArray);
      })
        .catch((err) => {
          console.error("Error fetching uploaded media: ", err);
          this.message = "Error fetching uploaded media.";
        });
    } 
  }

  ngAfterViewInit(){
    if(this.dbService.attendeesAdded){
      this.dialog.open(this.successfullyComplete);
    }
  }
  
  ngOnDestroy(): void {}

  
  publish() {
    console.log("Publishing unpublished uploads...");
    this.publishUrl = "https://publish.ceeyu.us?link=" + this.linkId+"&eventid=" + this.dbService.eventid ;
    window.location.href = this.publishUrl;
  }

  async delExpiredRoutelinks(){
    this.next = "";
    this.showNextStep = false;
    await firstValueFrom(this.dbService.delExpiredRoutelinks(this.http));
   
  }
  
  openDeleteEventDialog(){
    this.clearRadioButtons();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true; // Prevent closing by clicking outside
    dialogConfig.autoFocus = true; // Focus the first tabbable element
    dialogConfig.data = { // Pass data to the dialog component
      message: `${this.dbService.selectedEvent.title} has ${this.dbService.tableDataArray.length} photos.`,
    };

    const dialogRef = this.dialog.open(DeleteEventDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.confirm) {
        console.log(JSON.stringify(result));
        if(result.mode == "delete"){
          firstValueFrom(this.dbService.processEventChanges(this.dbService.selectedEvent, this.dbService.bk, "deleteevent", this.dbService.phone, this.dbService.visitorName, this.http))
          .then(() => {
            console.log("deleting event");
            const delDialogRef = this.dialog.open(this.successfullyDelete, {
              width: '300px',  
              height: 'auto'  
            });
            delDialogRef.afterClosed().subscribe(() => {this.goBack();})
          })
        }
      }else {
            console.log('User cancelled');
      }
    });
  }

  onNextStep(event){
    this.next = event.value;
    this.showNextStep = true;
  }

  onShowUploads(){
    this.next = "";
    this.showNextStep = false;
    this.showUploads = !this.showUploads;
  }
  
  onContinue(){
    switch(this.next){
      case "createevent":
        this.createNewEvent();
        break;
      case "adjustdatetime":
        this.openDateTimeDialog();
        break;
      case "showuploads":
        this.onShowUploads();
      break;
      case "addattendees":
        this.addAttendees();
      break; 
      case "publish":
        this.publish();
      break;
      case "deleteevent":
        this.openDeleteEventDialog();
      break;
      case "deletexpiredroutelinks":
        this.delExpiredRoutelinks();
        break;
    }
  }

  goBack(){
    const homeUrl = "https://www.ceeyu.us";
    window.location.href = homeUrl;
  }

  createNewEvent(){
     this.router.navigate(['createnewevent'], {skipLocationChange: true, state: {prev: "appcomponent", bk: this.dbService.bk, personid: this.dbService.bk, phone: this.dbService.phone}}); 
  }

  addAttendees(){
    this.router.navigate(['inviteattendee'], { skipLocationChange: true});
  } 


  openDateTimeDialog(): void {
    this.clearRadioButtons();
    const dialogRef = this.dialog.open(AdjustDateTimeDialogComponent, {
      width: '320px', 
      data: {eventtitle: this.dbService.selectedEvent.title}
    });

    dialogRef.afterClosed().subscribe(async result => {
      console.log('The dialog was closed');
      if(result){
        this.dbService.selectedEvent.fromdate = result.eventStartDate;
        this.dbService.selectedEvent.todate = result.eventEndDate;
        const hours = result.eventStartTime.getHours();
        const minutes = result.eventStartTime.getMinutes();
        this.dbService.selectedEvent.fromdate.setHours(hours, minutes, 0, 0);
        this.dbService.selectedEvent.eventstarttime = result.eventStartTime;
        const isActiveEvent = this.dbService.selectedEvent.fromdate.getDay() >= this.currentDate.getDay();
        if(!isActiveEvent){
          this.message = "Please select a valid date range for the event and try again";
        }else{
          let sixdays = Date.now() + 6*24*60*60*1000;
          //this.dbService.user.selectedevent = this.dataService.selectedEvent;
          const dateTimeJson = {firstexpiration: sixdays, fromdate: this.dbService.selectedEvent.fromdate, todate: this.dbService.selectedEvent.todate, eventstarttime: this.dbService.selectedEvent.eventstarttime};
          await firstValueFrom(this.dbService.updateEventDateTime(this.dbService.selectedEvent.eventid, dateTimeJson, this.http))
        }
      } 
    });
  }
  clearRadioButtons(): void {
    this.next = "";
    this.showNextStep = false;
    this.myForm.get('removetype')?.setValue(null);
  }

}
